import { CoreDataDictionaryViewsSharedKeyName } from './name';
import { deleteDataDictionaryShareView } from '@api';
import { updateCoreDataDictionaryViewsSyncSlice } from '../update';
import { createDeleteAsyncSlice, SagaYieldType } from '@sonar-software/xuder';

export const deleteCoreDataDictionaryViewsSharedKeyAsyncSlice = createDeleteAsyncSlice({
	httpSagaOptions: {
		successCombinationActionCreators: [
			(request) =>
				updateCoreDataDictionaryViewsSyncSlice.syncActionCreator({
					id: request.viewId,
					sharedKey: ''
				})
		]
	},
	name: CoreDataDictionaryViewsSharedKeyName,
	receive: true,
	request: true,
	requestHandler: deleteDataDictionaryShareView,
	yieldType: SagaYieldType.Every
});
